import {
  LayoutDashboard,
  ClipboardList,
  CreditCard,
  Wallet,
  DollarSign,
  FolderKanban,
  ChartSpline,
  Settings2,
  Sparkles,
} from "lucide-react"
import { NavItem } from "@/types/nav"

export const accountantNav: NavItem[] = [
  {
    title: "Dashboard",
    url: "/dashboard/account-payables/dashboard/overview",
    icon: LayoutDashboard,
  },
  {
    title: "Payables",
    url: "/dashboard/account-payables/payables",
    icon: CreditCard,
    items: [
      {
        title: "Upcoming",
        url: "/dashboard/account-payables/payables/upcoming",
      },
      {
        title: "Disbursed",
        url: "/dashboard/account-payables/payables/disbursed",
      },
      {
        title: "Flagged",
        url: "/dashboard/account-payables/payables/flagged",
      },
      {
        title: "Resident Funding",
        url: "/dashboard/account-payables/payables/resident-funding",
      },
    ],
  },
  {
    title: "Chargebacks",
    url: "/dashboard/account-receivables/receivables",
    icon: Wallet,
    // Draft / Approved / Flagged / Rejected sub-tabs are intentionally hidden
    // from the Accountant sidebar — pages still exist under
    // `app/dashboard/account-receivables/receivables/{draft,approved,flagged,rejected}/`
    // and respond to direct URLs (may be reused later).
    items: [
      {
        title: "Chargeback Batches",
        url: "/dashboard/account-receivables/receivables/batches",
      },
      {
        title: "Upcoming Chargeback",
        url: "/dashboard/account-receivables/receivables/upcoming",
      },
    ],
  },
  {
    title: "Financials",
    url: "/dashboard/company-admin/financials",
    icon: DollarSign,
    items: [
      {
        title: "Invoices",
        url: "/dashboard/company-admin/financials/invoices",
      },
      {
        title: "Funding",
        url: "/dashboard/company/funding-history",
      },
      // Reconciliation sub-tab intentionally hidden from the Accountant
      // sidebar. The page still exists at /dashboard/company/accounting-statements
      // and responds to direct URLs.
      {
        title: "Fees",
        url: "/dashboard/company-admin/financials/fees",
      },
    ],
  },
  {
    title: "Manage",
    url: "/dashboard/company-admin/manage",
    icon: FolderKanban,
    items: [
      {
        title: "Properties",
        url: "/dashboard/company-admin/manage/properties",
      },
      {
        title: "Residents",
        url: "/dashboard/utility-admin/manage/residents",
      },
    ],
  },
  {
    // Work orders raised on behalf of a resident, from the residents page.
    title: "Work Orders",
    url: "/dashboard/work-orders",
    icon: ClipboardList,
  },
  {
    title: "Reports",
    url: "/dashboard/account-payables/reports",
    icon: ChartSpline,
    items: [
      {
        title: "Funding History",
        url: "/dashboard/company/funding-history",
      },
      {
        title: "Fees Absorption",
        url: "/dashboard/account-payables/reports/fees-absorption",
      },
      {
        title: "Tenant Charges",
        url: "/dashboard/account-receivables/reports/tenant-charges",
      },
      {
        // The page lives under /dashboard/utility-admin/reports/sla-breach-report
        // (built by the feature/sla-breach-report PR that landed on main).
        // The accountant role needs access too, so role-navigation.ts
        // exact-path-allows this URL for accountant.
        title: "SLA Breach Report",
        url: "/dashboard/utility-admin/reports/sla-breach-report",
      },
    ],
  },
  {
    title: "AI Tools",
    url: "/dashboard/ai-tools",
    icon: Sparkles,
    items: [
      {
        title: "Fee Analyzer",
        url: "/dashboard/ai-tools/fee-analyzer",
      },
    ],
  },
  {
    title: "Settings",
    url: "/dashboard/account-payables/settings",
    icon: Settings2,
    items: [
      {
        title: "Entity Bank Accounts",
        url: "/dashboard/account-payables/settings/bank-accounts",
      },
      {
        title: "Charge Codes",
        url: "/dashboard/account-payables/settings/gl-codes",
      },
      {
        title: "Spike Thresholds",
        url: "/dashboard/account-payables/settings/spike-threshold",
      },
    ],
  },
]
